import { createContext } from 'react';
import ValueStore from '@dtvgo/value-store';
import { PlayerState, PlayerViewMode } from './constants.js';
import { EMPTY_ARRAY, noop } from './utils.js';

const PlayerStateContext = createContext(new ValueStore(PlayerState.UNKNOWN));
const PlayerBufferingContext = createContext(new ValueStore(false));
const PlayerSeekingContext = createContext(new ValueStore({
  isSeeking: false,
  time: void 0
}));
const PlayerViewModeContext = createContext(new ValueStore(PlayerViewMode.INLINE));
const PlayerTimeContext = createContext(new ValueStore(0));
const PlayerCurrentTimeContext = createContext(new ValueStore(0));
const PlayerDurationContext = createContext(new ValueStore(0));
const PlayerMaxTimeShiftContext = createContext(new ValueStore(0));
const PlayerVolumeContext = createContext(new ValueStore(100));
const AudioTracksContext = createContext(new ValueStore(EMPTY_ARRAY));
const SubtitleTracksContext = createContext(new ValueStore(EMPTY_ARRAY));
const PlayerActionsContext = createContext({
  play: noop,
  pause: noop,
  togglePlayPause: noop,
  goToFullScreen: noop,
  exitFullScreen: noop,
  toggleFullScreen: noop,
  seek: noop,
  rewind: noop,
  goToLive: noop,
  setVolume: noop,
  toggleMute: noop,
  selectAudioTrack: noop,
  selectSubtitleTrack: noop,
  disableSubtitles: noop,
  getAvailableAudio: noop,
  getAvailableSubtitles: noop
});

export { AudioTracksContext, PlayerActionsContext, PlayerBufferingContext, PlayerCurrentTimeContext, PlayerDurationContext, PlayerMaxTimeShiftContext, PlayerSeekingContext, PlayerStateContext, PlayerTimeContext, PlayerViewModeContext, PlayerVolumeContext, SubtitleTracksContext };
//# sourceMappingURL=contexts.js.map
